import React, { useState } from "react";
import { Form, FormGroup, Segment, Popup } from "semantic-ui-react";
import { useFormik } from "formik";
import { PaymentCategory } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { ListPaymentConcept } from "../ListPaymentConcept";
import { initialValues, validationSchema } from "./PaymentConceptFormEdit.form";
import "./PaymentConceptFormEdit.scss";

const paymentCategoryController = new PaymentCategory();

export function PaymentConceptFormEdit(props) {
  const { paymentConcept, onClose } = props;
  const [reload, setReload] = useState(null);
  const { accessToken } = useAuth();

  const onReload = () => setReload((prevState) => !prevState);

  const formik = useFormik({
    initialValues: initialValues(paymentConcept),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
          amount: formValue.amount,
          dueDate: formValue.dueDate,
          paymentCategoryId: paymentConcept.paymentCategoryId,
        };

        await paymentCategoryController.updatePaymentConcept(
          accessToken,
          paymentConcept.id,
          data
        );
        formik.resetForm();
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <Form.Input
          name="name"
          label="Nombre de concepto de pago"
          onChange={formik.handleChange}
          value={formik.values.name}
          error={formik.errors.name}
        />
        <Form.Input
          name="amount"
          label="S/. Monto"
          onChange={formik.handleChange}
          value={formik.values.amount}
          error={formik.errors.amount}
        />
        <Form.Input
          name="dueDate"
          type="date"
          label="Fecha de vencimiento"
          onChange={formik.handleChange}
          value={formik.values.dueDate}
          error={formik.errors.dueDate}
        />
        <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
          Actualizar concepto de pago
        </Form.Button>
      </Form>
    </>
  );
}
